import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '../Constants';
// import { MatDialogRef } from '@angular/material/dialog';

@Injectable()
export class GoToSearch {

  constructor(
    protected http: HttpClient,
    protected router: Router,
    // protected dialogRef: MatDialogRef<any>
  ) { }
    
  public onGotoInternoSearchtext(searchtext: string = "") {
    if (searchtext !== undefined && searchtext !== null && searchtext > "") {
      // this.dialogRef.close();
      this.router.navigate([Constants.LAYOUT_PERSONAS + '/find'], {queryParams: {searchtext}});
    }
  }
}
